<div>
<component v-if="shouldRenderConfig" v-bind:is="getContainerType" v-bind:class="getClassName">
    <appPageOptionAttributes
        v-if="!isSelect"
        v-for="(pageOptionAttributes,index) in getProductPageOptionValues"
        v-bind:key="index"
        v-bind:propsData="pageOptionAttributes"
        v-bind:code="code"
        v-bind:class="code"
    ></appPageOptionAttributes>       
    <select v-on:change="handleOptionChange" v-if="isSelect" :value="selectedValue"  v-bind:class="code">
        <option   v-for="(option,index) in getProductPageOptionValues" :selected="selectedValue == option.value"  :value="option.value">
            {{option.label}}
        </option>
    </select>
    <appInputCustomFormat v-if="code=='format'" v-bind:nrItems="getProductPageOptionValues.length"></appInputCustomFormat>
    
</component>
<!-- <button type="button" class="btn btn-primary mt-3"
v-on:click="moveNext"
>Continue ></button> -->
</div>
